import React from 'react'
import Hero from '../components/Hero'
import TextSection from '../components/TextSection'
import { textsection_sixEor } from '../data/TextsectionData'
import GlobalHiring from '../components/GlobalHiring'
import { EORservices, headings } from '../data/GlobalHiringData'
import CardSection from '../components/CardSection'
import { featureEorData_three } from '../data/CardSectionData'
import { featuresEor_three } from '../data/CardData'
import TextwithImage from '../components/TextwithImage'
import { textSections } from '../data/TextwithimageData'
import HireSection from '../components/HireSection'
import { hiringsectionincompany } from '../data/HiresectionData'
import { useNavigate } from 'react-router-dom'

const EOR = () => {
  const navigate = useNavigate();
    const buttons = [
        { text: "Speak to an expert" , buttonClass: "companyFirstbutton"  }
      ];
  return (
    <>
    <Hero
      title="Global Employer of Record"
      description="Expanding your business into new countries comes with complexities – such as employment laws, payroll, tax regulations, and compliance hurdles. Ampstekpay is here to help you navigate these challenges smoothly."
      buttonText="Connect with Expert"
      customClass="CompanyHiringBanner"
      imageSrc="images/hero.jpg"
      squareColor="CompanyHiringsquare-bg-color"
      onButtonClick={() => navigate('meet-the-experts')}
    />
    <TextSection data={textsection_sixEor} withSpan={false}/>
    <GlobalHiring services={EORservices} customClass='Eorservice' heading={headings.page1}/>
    <CardSection data={featureEorData_three} featuress={featuresEor_three} customClass ='EorCard' />
    <TextwithImage data={textSections.pageThreeEor}/>
    <HireSection
        imageSrc={hiringsectionincompany.imageSrc}
        title={hiringsectionincompany.title}
        description={hiringsectionincompany.description}
        buttonText={buttons}
        className={hiringsectionincompany.className}
      />
    </>
  )
}

export default EOR